<div class="sidenav-content">
    <div class="bcontainer2">
        <div class="main-content">
            <div class="spacer2"></div>

            <div class="containter">
                <!-- Header Section with Controls -->
                <div class="page-header">
                    <div class="header-top">
                        <div class="header-title-section">
                            <i class="fa fa-angle-left back-icon" aria-hidden="true" (click)="clearFilter()"
                                title="Go back"></i>
                            <div>
                                <h1 class="page-title">
                                    <i class="fa-solid fa-utensils title-icon"></i>
                                    Recipes
                                </h1>
                                <p class="page-subtitle">
                                    Saved step-by-step recipes and procedures
                                </p>
                            </div>
                        </div>

                        <!-- Stats and Controls -->
                        <div class="header-controls">
                            <div class="stats-badge" *ngIf="!loading">
                                <i class="fa-solid fa-bowl-food"></i>
                                <span>{{ totalRecipes }} total</span>
                            </div>

                            <!-- View Toggle -->
                            <!-- Whose memories: only shown once something shared is actually here, so
                                 a workspace with no sharing sees no extra chrome. -->
                            <div class="owner-filter" *ngIf="sharedCount > 0">
                              <button class="owner-btn" [class.active]="ownerFilter === 'ALL'"
                                (click)="setOwnerFilter('ALL')" title="Everything you can read">
                                All <span class="owner-count">{{ recipelist.length }}</span>
                              </button>
                              <button class="owner-btn" [class.active]="ownerFilter === 'MINE'"
                                (click)="setOwnerFilter('MINE')" title="Only what you wrote">
                                Mine <span class="owner-count">{{ ownCount }}</span>
                              </button>
                              <button class="owner-btn" [class.active]="ownerFilter === 'SHARED'"
                                (click)="setOwnerFilter('SHARED')" title="Only what was shared with you">
                                Shared <span class="owner-count">{{ sharedCount }}</span>
                              </button>
                            </div>
                            <div class="view-toggle">
                                <button class="view-btn" [class.active]="viewMode === 'grid'"
                                    (click)="setViewMode('grid')" title="Grid view">
                                    <i class="fa-solid fa-grip"></i>
                                </button>
                                <button class="view-btn" [class.active]="viewMode === 'list'"
                                    (click)="setViewMode('list')" title="List view">
                                    <i class="fa-solid fa-list"></i>
                                </button>
                                <button class="view-btn" [class.active]="viewMode === 'compact'"
                                    (click)="setViewMode('compact')" title="Compact view">
                                    <i class="fa-solid fa-bars"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- Search and Filter Bar -->
                    <div class="controls-bar">
                        <div class="search-box">
                            <i class="fa-solid fa-search search-icon"></i>
                            <input type="text" placeholder="Search recipes or steps..." [(ngModel)]="searchQuery"
                                (input)="onSearchChange()" class="search-input" />
                            <button class="clear-search-btn" *ngIf="searchQuery" (click)="clearSearch()"
                                title="Clear search">
                                <i class="fa-solid fa-times"></i>
                            </button>
                        </div>

                        <div class="control-group">
                            <!-- Items per page selector -->
                            <div class="items-selector">
                                <label>Show:</label>
                                <select [(ngModel)]="itemsPerPage" (change)="onItemsPerPageChange()"
                                    class="select-input">
                                    <option [value]="10">10</option>
                                    <option [value]="25">25</option>
                                    <option [value]="50">50</option>
                                    <option [value]="100">100</option>
                                </select>
                            </div>

                            <!-- Sort selector -->
                            <div class="sort-selector">
                                <label>Sort:</label>
                                <select [(ngModel)]="sortBy" (change)="onSortChange()" class="select-input">
                                    <option value="date-desc">Newest First</option>
                                    <option value="date-asc">Oldest First</option>
                                    <option value="steps-desc">Most Steps</option>
                                    <option value="steps-asc">Fewest Steps</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Filter Banners -->
                <div class="tag-filter-banner modern-banner" *ngIf="isFilteredByTag">
                    <div class="filter-content">
                        <i class="fa-solid fa-tag"></i>
                        <span>Showing recipes tagged with <strong>{{ selectedTag }}</strong></span>
                    </div>
                    <button class="clear-filter-btn" (click)="clearFilter()">
                        <i class="fa-solid fa-times"></i> Clear
                    </button>
                </div>

                <div class="token-filter-banner modern-banner" *ngIf="isFilteredByToken">
                    <div class="filter-content">
                        <i class="fa-solid fa-search"></i>
                        <span>Showing recipes with keyword <strong>{{ selectedTokens[0] }}</strong></span>
                    </div>
                    <button class="clear-filter-btn" (click)="clearFilter()">
                        <i class="fa-solid fa-times"></i> Clear
                    </button>
                </div>

                <!-- Results Summary -->
                <div class="results-summary" *ngIf="!loading && paginatedRecipes.length > 0">
                    <span>Showing {{ getStartIndex() + 1 }}-{{ getEndIndex() }} of
                        {{ filteredRecipes.length }} recipes</span>
                </div>

                <!-- Loading State -->
                <div class="loading-container" *ngIf="loading">
                    <div class="spinner"></div>
                    <p>Loading recipes...</p>
                </div>

                <!-- Empty State -->
                <div class="empty-state" *ngIf="!loading && (!recipelist || recipelist.length === 0)">
                    <div class="empty-icon">
                        <i class="fa-solid fa-utensils"></i>
                    </div>
                    <h3 class="empty-title">
                        {{
                        isFilteredByTag
                        ? "No recipes found for this tag"
                        : isFilteredByToken
                        ? "No recipes found for this keyword"
                        : "No recipes yet"
                        }}
                    </h3>
                    <p class="empty-description">
                        {{
                        isFilteredByTag || isFilteredByToken
                        ? "Try clearing the filter to see all recipes"
                        : "Start creating recipes to see them here"
                        }}
                    </p>
                    <button class="btn-primary" *ngIf="isFilteredByTag || isFilteredByToken" (click)="clearFilter()">
                        <i class="fa-solid fa-times"></i> Clear Filter
                    </button>
                </div>

                <!-- Recipes Grid/List -->
                <div class="recipes-container" [class.grid-view]="viewMode === 'grid'"
                    [class.list-view]="viewMode === 'list'" [class.compact-view]="viewMode === 'compact'"
                    *ngIf="!loading && paginatedRecipes && paginatedRecipes.length > 0">
                    <div class="recipe-card" *ngFor="let recipe of paginatedRecipes; let i = index">
                        <!-- Card Header -->
                        <div class="card-header">
                            <div class="recipe-number">
                                <i class="fa-solid fa-book-open"></i>
                                <span>#{{ getStartIndex() + i + 1 }}</span>
                            </div>
                            <span class="shared-badge" *ngIf="recipe?.isShared === true && recipe?.sharedFrom?.name"
                              [title]="'Shared into ' + recipe?.sharedFrom?.name">
                              <i class="fa-solid fa-share-nodes"></i>
                              {{ recipe?.sharedFrom?.name }}
                            </span>
                            <!-- Actions stay put. isShared cannot currently mean "somebody else wrote
                                 this": the listMemory projection carries no author, so a memory of your
                                 own that you shared OUT is flagged the same way. Hiding the controls on
                                 it left you unable to unshare or forget your own memory. The server is
                                 the real check - forget and share both refuse anything that is not
                                 yours - so showing the buttons costs nothing. -->
                                                        <div class="card-actions">
                            <button class="action-btn share-btn" (click)="shareRecipe($event, recipe)"
                                title="Share into a workspace">
                                <i class="fa-solid fa-share-nodes"></i>
                            </button>
                                <button class="action-btn copy-btn" (click)="copyMessage(recipe?.memory)"
                                    title="Copy recipe name">
                                    <i class="fa-solid fa-copy"></i>
                                </button>
                                <button class="action-btn delete-btn" (click)="showForgetRecipePopup($event, recipe)"
                                    title="Forget this recipe">
                                    <i class="fa-solid fa-trash"></i>
                                </button>
                            </div>
                        </div>

                        <!-- Recipe Title -->
                        <div class="card-content">
                            <p class="recipe-text">{{ recipe?.memory }}</p>
                        </div>

                        <!-- Steps Section -->
                        <div class="steps-section" *ngIf="recipe?.steps && recipe.steps.length > 0">
                            <div class="steps-label">
                                <i class="fa-solid fa-list-ol"></i>
                                <span>{{ recipe.steps.length }} Steps</span>
                            </div>
                            <ol class="steps-list">
                                <li class="step-item" *ngFor="let step of recipe.steps">
                                    <span class="step-marker">{{ step.order }}</span>
                                    <span class="step-text">{{ step.text }}</span>
                                </li>
                            </ol>
                        </div>

                        <!-- Keywords Section -->
                        <div class="keywords-section" *ngIf="recipe?.tokens && recipe.tokens.length > 0">
                            <div class="keywords-label">
                                <i class="fa-solid fa-tags"></i>
                                <span>Keywords</span>
                            </div>
                            <div class="keywords-list">
                                <span *ngFor="let token of recipe?.tokens" class="keyword-chip"
                                    (click)="filterByToken(token)" [title]="'Filter by: ' + token">
                                    <i class="fa-solid fa-hashtag"></i>
                                    {{ token }}
                                </span>
                            </div>
                        </div>

                        <!-- Tag Section (notesKey) -->
                        <div class="tag-section" *ngIf="recipe?.notesKey">
                            <div class="tag-label">
                                <i class="fa-solid fa-tag"></i>
                                <span>Tag</span>
                            </div>
                            <span class="tag-badge" (click)="filterByTag(recipe.notesKey)"
                                [title]="'Filter by tag: ' + recipe.notesKey">
                                <i class="fa-solid fa-bookmark"></i>
                                {{ recipe.notesKey }}
                            </span>
                        </div>

                        <!-- Card Footer -->
                        <div class="card-footer">
                            <div class="metadata-item" [title]="'Hash: ' + recipe?.queryHash">
                                <i class="fa-solid fa-fingerprint"></i>
                                <span class="metadata-text">{{ recipe?.queryHash | slice : 0 : 12 }}...</span>
                            </div>
                            <div class="metadata-item" [title]="'Created: ' + recipe?.date">
                                <i class="fa-solid fa-clock"></i>
                                <span class="metadata-text">{{ recipe?.date }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Pagination Controls -->
                <div class="pagination-container" *ngIf="!loading && filteredRecipes.length > itemsPerPage">
                    <div class="pagination-info">
                        Page {{ currentPage }} of {{ totalPages }}
                    </div>

                    <div class="pagination-controls">
                        <button class="page-btn" [disabled]="currentPage === 1" (click)="goToFirstPage()"
                            title="First page">
                            <i class="fa-solid fa-angles-left"></i>
                        </button>

                        <button class="page-btn" [disabled]="currentPage === 1" (click)="previousPage()"
                            title="Previous page">
                            <i class="fa-solid fa-angle-left"></i>
                            Previous
                        </button>

                        <!-- Page numbers -->
                        <div class="page-numbers">
                            <button *ngFor="let page of getPageNumbers()" class="page-number-btn"
                                [class.active]="page === currentPage" [class.ellipsis]="page === -1"
                                [disabled]="page === -1" (click)="goToPage(page)">
                                {{ page === -1 ? "..." : page }}
                            </button>
                        </div>

                        <button class="page-btn" [disabled]="currentPage === totalPages" (click)="nextPage()"
                            title="Next page">
                            Next
                            <i class="fa-solid fa-angle-right"></i>
                        </button>

                        <button class="page-btn" [disabled]="currentPage === totalPages" (click)="goToLastPage()"
                            title="Last page">
                            <i class="fa-solid fa-angles-right"></i>
                        </button>
                    </div>

                    <div class="quick-jump">
                        <label>Go to page:</label>
                        <input type="number" [min]="1" [max]="totalPages" [(ngModel)]="jumpToPageNumber"
                            (keyup.enter)="jumpToPage()" class="page-jump-input" />
                        <button class="btn-secondary" (click)="jumpToPage()">Go</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Forget Recipe Popup -->
    <div class="forget-popup-overlay" *ngIf="showForgetPopup" (click)="closeForgetPopup()"></div>

    <div class="forget-popup-card modern-popup" *ngIf="showForgetPopup" [style.top.px]="popupPosition.top"
        [style.left.px]="popupPosition.left">
        <div class="popup-header">
            <i class="fa-solid fa-exclamation-triangle warning-icon"></i>
            <h3>Forget Recipe?</h3>
        </div>

        <div class="popup-body">
            <p>This recipe will be permanently removed and cannot be recovered.</p>
            <div class="recipe-preview">
                <i class="fa-solid fa-quote-left"></i>
                <p>
                    {{ selectedRecipe?.memory | slice : 0 : 100
                    }}{{ selectedRecipe?.memory?.length > 100 ? "..." : "" }}
                </p>
                <i class="fa-solid fa-quote-right"></i>
            </div>
        </div>

        <div class="popup-footer">
            <button class="btn-secondary" (click)="closeForgetPopup()">
                <i class="fa-solid fa-times"></i> Cancel
            </button>
            <button class="btn-danger" (click)="forgetRecipe()">
                <i class="fa-solid fa-trash"></i> Forget Recipe
            </button>
        </div>
    </div>
</div>